<template>
    <div>
        <div v-if="isTableDataLoading">
            <Loader />
        </div>

        <div class="tw-mx-2  tw-mt-4">
            <div
                class="card tw-flex  tw-flex-col md:tw-flex-row tw-justify-between tw-items-center  tw-w-full tw-border-0 tw-p-4 tw-mb-4 tw-bg-white tw-rounded-lg">
                <div id="werehouseDateRange"
                    class="tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-w-full tw-gap-4">
                    <div class="tw-w-full md:tw-w-auto tw-mt-[7px]">
                        <div
                            class="tw-text-[#050A13] tw-text-xs sm:tw-text-sm md:tw-text-base tw-mb-2 sm:tw-mb-3 tw-mx-1">
                            Vehicle Date
                        </div>
                        <date-range-picker v-model="dateRange" :show-dropdowns="true" opens="right" :autoApply="true"
                            :locale-data="{ format: 'dd mmm yyyy' }"  @update="dataAPIs"
                            class="tw-w-full tw-min-w-0">
                        </date-range-picker>
                    </div>
                    <div class="tw-w-full md:tw-w-auto" v-if="viewTableAndCardData.putaway_date">
                         <div
                            class="tw-text-[#050A13] tw-text-xs sm:tw-text-sm md:tw-text-base tw-mb-2 sm:tw-mb-3 tw-mx-1">
                            PO Date
                        </div>
                        <div class="tw-flex tw-border tw-text-base tw-border-base_color-80 tw-h-[34px] tw-w-[180px] tw-rounded-[5px] tw-p-2 tw-px-3 sm:tw-py-1  tw-bg-[#d4d4d4AA] tw-shadow-sm">
                           <img src="Icons_SVG/calenderIcon.svg" class="tw-mr-2 tw-h-[16px] tw-mt-1"/>
                            <span>{{ viewTableAndCardData.po_date }}</span>
                        </div>
                    </div >
                    <!-- <div class="tw-w-full md:tw-w-auto" v-if="viewTableAndCardData.putaway_date">
                         <div
                            class="tw-text-[#050A13] tw-text-xs sm:tw-text-sm md:tw-text-base tw-mb-2 sm:tw-mb-3 tw-mx-1">
                            Vehicle Date
                        </div>
                         <div class="tw-flex tw-border tw-text-base tw-border-base_color-80 tw-h-[34px] tw-w-[180px] tw-rounded-[5px] tw-p-2 tw-px-3 sm:tw-py-1  tw-bg-[#d4d4d4AA] tw-shadow-sm">
                           <img src="Icons_SVG/calenderIcon.svg" class="tw-mr-2 tw-h-[16px] tw-mt-1"/>
                            <span>{{ viewTableAndCardData.vehicle_date }}</span>
                        </div>
                    </div> -->
                     <div class="tw-w-full md:tw-w-auto " v-if="viewTableAndCardData.putaway_date">
                         <div
                            class="tw-text-[#050A13] tw-text-xs sm:tw-text-sm md:tw-text-base tw-mb-2 sm:tw-mb-3 tw-mx-1">
                            Putaway Date
                        </div>
                        <div class="tw-flex tw-border tw-text-base tw-border-base_color-80 tw-h-[34px] tw-w-[180px] tw-rounded-[5px] tw-p-2 tw-px-3 sm:tw-py-1  tw-bg-[#d4d4d4AA] tw-shadow-sm">
                           <img src="Icons_SVG/calenderIcon.svg" class="tw-mr-2 tw-h-[16px] tw-mt-1"/>
                            <span>{{ viewTableAndCardData.putaway_date }}</span>
                        </div>
                    </div>
                     <div class="tw-w-full md:tw-w-auto " v-if="viewTableAndCardData.putaway_date">
                         <div
                            class="tw-text-[#050A13] tw-text-xs sm:tw-text-sm md:tw-text-base tw-mb-2 sm:tw-mb-3 tw-mx-1">
                            PO Ref No.
                        </div>
                        <div class="tw-flex tw-border tw-text-base tw-border-base_color-80 tw-h-[34px] tw-w-[230px] tw-rounded-[5px] tw-p-2 tw-px-3 sm:tw-py-1  tw-bg-[#d4d4d4AA] tw-shadow-sm">
                           <!-- <img src="Icons_SVG/calenderIcon.svg" class="tw-mr-2 tw-h-[16px] tw-mt-1"/> -->
                            <span>{{ viewTableAndCardData.po_ref_no }}</span>
                        </div>
                    </div>
                </div>
                <div class="tw-flex tw-flex-col sm:tw-flex-row tw-items-center tw-gap-2 tw-mt-4 sm:tw-mt-0">
                <button
                    class="ui button exportButton tw-flex tw-items-center tw-ml-0 sm:tw-ml-1 tw-text-sm sm:tw-text-base tw-px-3 sm:tw-px-6 tw-py-2"
                    @click="exportGRNAllData">
                    <svg v-if="isGRNAllExporting" aria-hidden="true" role="status"
                        class="tw-inline tw-w-4 tw-h-4 tw-mr-1 tw-text-white tw-animate-spin"
                        viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="#E5E7EB" />
                        <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentColor" />
                    </svg>
                    <div>{{ isGRNAllExporting ? 'Exporting...' : 'Export' }}</div>
                </button>
                <!-- <button @click="isUploadModal = true"
                    class="ui button exportButton tw-bg-accent_color tw-ml-0 sm:tw-ml-1 tw-text-sm sm:tw-text-base tw-px-3 sm:tw-px-6 tw-py-2">
                    Upload
                </button> -->
                </div>
            </div>
            <div class="">
                <div class="card tw-border-0 tw-mb-4 tw-z-[10] tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-3 xl:tw-grid-cols-5 tw-gap-4" v-if="viewCartData.length"> 
                    <div v-for="(card,idx) of viewCartData" :key="idx">
                        <div class="tw-flex tw-border-[1px] tw-border-[#D4D4D4] tw-rounded-[5px] tw-p-3 sm:tw-p-4 tw-bg-white tw-shadow-sm">
                            <div class="tw-mb-3 sm:tw-mb-4  tw-flex-wrap">
                                <img :src="'Icons_SVG/'+metricIconMapper[card.label]+'.svg'" class="tw-mr-[20px] tw-w-[32px] tw-h-[32px]"/>
                            </div>
                            <div class="">
                                <div class="tw-text-[12px] sm:tw-text-[14px] tw-text-[#5E5E5E] tw-font-semibold tw-capitalize tw-truncate">{{ card.label }}</div>
                                <div class="tw-mt-1 sm:tw-mt-2 tw-text-[18px] sm:tw-text-[24px] tw-text-[#000] tw-font-semibold tw-truncate">{{formatNumber(card.value)}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card tw-grid  tw-border-0 tw-mb-4 tw-z-[10]" v-else>
                    <noData :loaderVariable="isTableDataLoading"/>
                </div>
            </div>
            <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-4">
                <!-- Summary Table -->
                <div class="card tw-border-0 summaryContainer tw-m-0 tw-mb-4  tw-z-[10]">
                    <div>
                        <div
                            class="tw-flex  sm:tw-flex-row tw-justify-between tw-items-start sm:tw-items-center tw-pb-2 tw-mb-4 tw-border-b-[1px] tw-border-[#D4D4D4] tw-gap-4">
                            <div
                                class="tw-text-[14px] sm:tw-text-[16px] tw-text-[#065559] tw-font-[600] tw-pb-1 tw-mb-2">
                                GRN Reco - Short</div>
                            <div class="tw-flex sm:tw-flex-row tw-gap-2">
                                <button
                                    class="ui button exportButton tw-ml-0 sm:tw-ml-1 tw-text-sm sm:tw-text-base tw-px-3 sm:tw-px-6 tw-py-2"
                                    @click="exportGRMShortData">
                                    <svg v-if="isShortExporting" aria-hidden="true" role="status"
                                        class="tw-inline tw-w-4 tw-h-4 tw-mr-1 tw-text-white tw-animate-spin"
                                        viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                            fill="#E5E7EB" />
                                        <path
                                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                            fill="currentColor" />
                                    </svg>
                                    {{ isShortExporting ? 'Exporting...' : 'Export' }}
                                </button>
                            </div>
                        </div>
                    </div> 
                    <div v-if="Object.keys(viewGRNShortTableData).length">
                        <table id="GRMSort" class="tw-w-full tw-mt-3 tw-min-h-[100px]">
                            <thead>
                                <tr>
                                    <th v-for="(item, index) in viewGRNShortTableData.headers" :key="index">
                                        <span>{{ item.value }}</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, idx) in viewGRNShortTableData.data" :key="idx"
                                    v-if="item.key != 'Total'">
                                    <td v-for="(head, index) in viewGRNShortTableData.headers" :key="index">
                                        {{ formatNumber(item[head.key]) }}
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr v-for="(item, index) in viewGRNShortTableData.data" :key="index"
                                    v-if="String(item.key).includes('Total')"
                                    class="tw-bg-[#7f8f901a] tw-text-![#5E5E5E]">
                                    <td v-for="(head, index) in viewGRNShortTableData.headers" :key="index"
                                        class="tw-text-[#5E5E5E]">
                                        <span> {{ formatNumber(item[head.key]) }} </span>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                    <div v-else class="tw-min-h-[400px]">
                        <noData :loaderVariable="isTableDataLoading" />
                    </div>
                </div>
                <div class="card tw-border-0 summaryContainer tw-m-0 tw-mb-4  tw-z-[10]">
                    <div>
                        <div
                            class="tw-flex  sm:tw-flex-row tw-justify-between tw-items-start sm:tw-items-center tw-pb-2 tw-mb-4 tw-border-b-[1px] tw-border-[#D4D4D4] tw-gap-4">
                            <div
                                class="tw-text-[14px] sm:tw-text-[16px] tw-text-[#065559] tw-font-[600] tw-pb-1 tw-mb-2">
                                GRN Reco - Excess</div>
                            <div class="tw-flex sm:tw-flex-row tw-gap-2">
                                <button
                                    class="ui button exportButton tw-ml-0 sm:tw-ml-1 tw-text-sm sm:tw-text-base tw-px-3 sm:tw-px-6 tw-py-2"
                                    @click="exportGRMExcessData">
                                    <svg v-if="isExcessExporting" aria-hidden="true" role="status"
                                        class="tw-inline tw-w-4 tw-h-4 tw-mr-1 tw-text-white tw-animate-spin"
                                        viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                            fill="#E5E7EB" />
                                        <path
                                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                            fill="currentColor" />
                                    </svg>
                                    {{ isExcessExporting ? 'Exporting...' : 'Export' }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div v-if="Object.keys(viewGRNExcessTableData).length">
                        <table id="GRMExcess" class="tw-w-full tw-mt-3 tw-min-h-[100px]">
                            <thead>
                                <tr>
                                    <th v-for="(item, index) in viewGRNExcessTableData.headers" :key="index">
                                        <span>{{ item.value }}</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, idx) in viewGRNExcessTableData.data" :key="idx"
                                    v-if="item.key != 'Total'">
                                    <td v-for="(head, index) in viewGRNExcessTableData.headers" :key="index">
                                        {{ formatNumber(item[head.key]) }}
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr v-for="(item, index) in viewGRNExcessTableData.data" :key="index"
                                    v-if="String(item.key).includes('Total')"
                                    class="tw-bg-[#7f8f901a] tw-text-![#5E5E5E]">
                                    <td v-for="(head, index) in viewGRNExcessTableData.headers" :key="index"
                                        class="tw-text-[#5E5E5E]">
                                        <span> {{ formatNumber(item[head.key]) }} </span>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                    <div v-else class="tw-min-h-[400px]">
                        <noData :loaderVariable="isTableDataLoading" />
                    </div>
                </div>
            </div>
        </div>
        <b-modal v-model="isUploadModal">
            <template #modal-title>
                <div>
                    <h5 class="tw-text-[#00555A] tw-text-[16px] tw-mb-0">Upload</h5>
                </div>
            </template>
            <div class="modal-delete-content tw-pt-0">
                <div class="tw-text-[#050A13] tw-text-[14px] tw-mb-3 tw-mx-1">
                    Vehicle Date
                </div>
                <date-range-picker v-model="VDDateRange" :show-dropdowns="true" opens="right" :autoApply="true"
                    :locale-data="{ format: 'dd mmm yyyy' }" :max-date="maxDate" @update="formateDate"
                    class="tw-w-full tw-min-w-0" :single-date-picker="true"  :ranges="false">
                </date-range-picker>

                <div class="tw-grid tw-grid-cols-2 tw-mt-6 tw-gap-6">
                    <div>
                        <div class="">
                            <div class="tw-text-[#050A13] tw-text-[14px] tw-mb-3 tw-mx-1">
                                Linking Sheet
                            </div>
                            <input :disabled="linkingSheetLoader" type="file" class="d-none" accept=".xlsx"
                                id="row.platform_id + '_file'" onclick="this.value = null" @change="uploadLinkingSheet($event)"/>
                            <label for="row.platform_id + '_file'" class="tw-mb-0 tw-w-full">
                                <div
                                    class="btn primarycolor tw-bg-accent_color tw-text-[#fff] tw-text-base tw-font-bold tw-w-full">
                                    {{ linkingSheetLoader ? "Uploading..." : "Upload" }}
                                </div>
                            </label>
                            <div class="tw-mt-1 tw-text-[12px]">{{ linkingSheetFileName }}</div>
                        </div>
                    </div>
                    <div>
                        <div class="tw-w-full">
                            <div class="tw-text-[#050A13] tw-text-[14px] tw-mb-3 tw-mx-1">
                                GRN Sheet
                            </div>
                            <input :disabled="GRNSheetLoader" type="file" class="d-none" accept=".xlsx" id="GRNSheet"
                                onclick="this.value = null" @change="uploadGRNSheet($event)"/>
                            <label for="GRNSheet" class="tw-mb-0 tw-w-full">
                                <div
                                    class="btn primarycolor tw-bg-accent_color tw-text-[#fff] tw-text-base tw-font-bold tw-w-full">
                                    {{ GRNSheetLoader ? "Uploading..." : "Upload" }}
                                </div>
                            </label>
                            <div class="tw-mt-1 tw-text-[12px]">{{ GRNSheetFileName }}</div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="tw-border tw-border-b-[1px] tw-border-[#D4D4D4] tw-my-6"></div>
            <div class="tw-grid tw-grid-cols-2 tw-gap-4 ">
                <div>
                    <div class="tw-text-[#050A13] tw-text-[14px] tw-mb-3 tw-mx-1">
                        PO Date
                    </div>
                    <date-range-picker v-model="PDDateRange" :show-dropdowns="true" opens="right" :autoApply="true"
                        :locale-data="{ format: 'dd mmm yyyy' }" :max-date="maxDate" @update="formateDate"
                        class="tw-w-full tw-min-w-0"  :single-date-picker="true" :ranges="false">
                    </date-range-picker>
                </div>
                <div>
                    <div class="tw-text-[#050A13] tw-text-[14px] tw-mb-3 tw-mx-1">
                        Putaway Date
                    </div>
                    <date-range-picker v-model="PutwayDateRange" :show-dropdowns="true" opens="right" :autoApply="true"
                        :locale-data="{ format: 'dd mmm yyyy' }" :max-date="maxDate" @update="formateDate"
                        class="tw-w-full tw-min-w-0" :single-date-picker="true" :ranges="false">
                    </date-range-picker>
                </div>

            </div>
            <div class="tw-flex tw-justify-end tw-mt-8">
                <b-button @click="
                    () => {
                        isUploadModal = false;
                    }
                " class="btn primarycolor mr-2 d-flex align-items-center delete-requestBtn"
                    style="background-color: var(--red)">Cancel</b-button>
                <button class="btn primarycolor" :disabled="isUploading" @click="handUploadFile">
                    <span> {{ isUploading ? "Saving..." : "Save" }}</span>
                </button>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import Multiselect from "vue-multiselect";
import Loader from "../Components/Loader.vue";
import dynamicChart from "../commonCharts/Chart/dynamicChart.vue";
import pieChart from "../commonCharts/Chart/commonPieChart.vue";
import StateMapper from '../commonCharts/IndiaState.json'
import indiaMap from "../commonCharts/IndiaMap.vue";
import stackChart from "../commonCharts/StackChart.vue";
import noData from "../Components/noData.vue";

export default {
    name: "GRN Reco",
    components: { Datepicker, Multiselect, Loader, dynamicChart, pieChart, indiaMap, stackChart, noData },
    data: function () {
        return {
            dropownLoader: false,
            dateRange: {
                startDate: moment().format("YYYY-MM-DD"),
                endDate: moment().format("YYYY-MM-DD"),
            },
            VDDateRange: {
                startDate: moment().format("YYYY-MM-DD"),
                endDate: moment().format("YYYY-MM-DD"),
            },
             PDDateRange: {
                startDate: moment().format("YYYY-MM-DD"),
                endDate: moment().format("YYYY-MM-DD"),
            },
            PutwayDateRange: {
                startDate: moment().format("YYYY-MM-DD"),
                endDate: moment().format("YYYY-MM-DD"),
            },
            channelList: '',
            selectedChannel: '',
            // Loader Section start
            isGRNAllExporting: false,
            isShortExporting: false,
            isExcessExporting: false,
            isAllDownload: false,
            isTableDataLoading: false,
            linkingSheetLoader: false,
            GRNSheetLoader: false,
            isUploading: false,
            // loader Section end
            linkingSheetFileName:'',
            GRNSheetFileName:'',
            maxDate: new Date(),
            viewTableAndCardData: {},
            viewCartData:[],
            viewGRNShortTableData:{},
            viewGRNExcessTableData:{},
            dataForExport: {},
            isUploadModal: false,
            uploadedLinkingSheet: null,
            uploadedGRNSheet: null,
            metricIconMapper: {
                "Total Po Qty": "RTO_invoice_amount",
                "Short (-)": "Minus",
                "Excess (+)": "Plus",
                "Total GRN Done": "RTO_invoice_amount",
                "Total Invoice": "totalInvoice",

            },
        };
    },
    created(){
        this.dataAPIs();
    },

    mounted() {
        // this.getDropdownData();
        this.$store.dispatch("DemoStore/setTimeStamp", '');
        this.$store.dispatch("DemoStore/setUpdatedStatus", "");
    },
    watch: {
        selectedInterval: function () {
            this.getTableandCardData();
        },
    },

    methods: {

        dataAPIs() {
            if ($.fn.DataTable.isDataTable('#GRMSort')) {
                $('#GRMSort').DataTable().destroy();
            }
            if ($.fn.DataTable.isDataTable('#GRMExcess')) {
                $('#GRMExcess').DataTable().destroy();
            }
            this.getTableandCardData();

        },

        formateDate() {
            this.dateRange.startDate = moment(this.dateRange.startDate).format("YYYY-MM-DD");
            this.dateRange.endDate = moment(this.dateRange.endDate).format("YYYY-MM-DD");
            this.VDDateRange.startDate = moment(this.VDDateRange.startDate).format("YYYY-MM-DD");
            this.VDDateRange.endDate = moment(this.VDDateRange.endDate).format("YYYY-MM-DD");
            this.PDDateRange.startDate = moment(this.PDDateRange.startDate).format("YYYY-MM-DD");
            this.PDDateRange.endDate = moment(this.PDDateRange.endDate).format("YYYY-MM-DD");
            this.PutwayDateRange.startDate = moment(this.PutwayDateRange.startDate).format("YYYY-MM-DD");
            this.PutwayDateRange.endDate = moment(this.PutwayDateRange.endDate).format("YYYY-MM-DD");
        },

        formatNumber(num) {
            if (isNaN(num)) return num
            let num1 = Number(num).toFixed(2);
            let num2 = Number(num1).toLocaleString();
            return num2
        },
        uploadGRNSheet(e){
            this.GRNSheetLoader = true
            this.uploadedGRNSheet = e.target.files[0];
            this.GRNSheetFileName = e.target.files[0].name
            this.GRNSheetLoader = false
        },
        uploadLinkingSheet(e){
            this.linkingSheetLoader = true
            this.uploadedLinkingSheet = e.target.files[0];
            this.linkingSheetFileName = e.target.files[0].name

            this.linkingSheetLoader = false
        },

        handUploadFile() {
            const formData = new FormData();
            formData.append('vehicle_date', this.VDDateRange.startDate);
            formData.append('po_date', this.PDDateRange.startDate);
            formData.append('putaway_date', this.PutwayDateRange.startDate);
            if(this.uploadedLinkingSheet){
                formData.append('link', this.uploadedLinkingSheet);
            }
            else{
                this.$bvToast.toast("Please upload Linking Sheet", {
                    title: 'Weavr Sense',
                    variant: 'danger',
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 3000,
                });
                return
            }
            if(this.uploadedGRNSheet){
                formData.append('reco', this.uploadedGRNSheet);
            }
            else{
                 this.$bvToast.toast("Please upload GRN Sheet", {
                    title: 'Weavr Sense',
                    variant: 'danger',
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 3000,
                });
                return
            }

            this.isUploading= true
            this.$http.post('/api/unicommerce/grn_reco/reco', formData).then(response => {
                this.linkingSheetLoader = false
                this.GRNSheetLoader = false
                this.uploadedLinkingSheet = null
                this.uploadedGRNSheet = null
                this.isUploading= false
                this.isUploadModal = false
                this.$bvToast.toast(response.data.message, {
                    title: 'Weavr Sense',
                    variant: 'success',
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 3000,
                });
                this.getTableandCardData()
            }).catch(error => {
                this.linkingSheetLoader = false
                this.GRNSheetLoader = false
                this.uploadedLinkingSheet = null
                this.uploadedGRNSheet = null
                this.isUploading= false
                this.isUploadModal = false
            });
        },
        
       
        getTableandCardData() {
            this.isTableDataLoading = true
            this.viewTableAndCardData = {}
            this.viewCartData = []
            this.viewGRNShortTableData = {}
            this.viewGRNExcessTableData = {}
            let url = "/api/unicommerce/grn_reco/reco?start_date="+moment(this.dateRange.startDate).format("YYYY-MM-DD")
            url += '&end_date='+moment(this.dateRange.endDate).format("YYYY-MM-DD")
            this.$http.get(url).then(response => {
                this.isTableDataLoading = false;
                this.viewTableAndCardData = response.data.data;
                this.viewCartData = response.data.data.cards;
                this.viewGRNShortTableData = response.data.data?.table.short;
                this.viewGRNExcessTableData = response.data.data.table.excess;
                // console.log("viewGRNExcessTableData", this.viewGRNExcessTableData);
                this.dataForExport = response.data
                this.$nextTick(() => {
                    this.processTable("#GRMSort")
                    this.processTable("#GRMExcess")
                })
            }).catch(error => {
                this.isTableDataLoading = false
                this.viewTableAndCardData = ''
            });
        },

         exportGRNAllData() {
            this.isGRNAllExporting = true
            const url = "/api/unicommerce/grn_reco/download";
            const payload = {
                start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
                end_date:  moment(this.dateRange.endDate).format("YYYY-MM-DD")
            };
            this.$http.post(url, payload)
                .then((response) => {
                    window.location = response.data?.data;
                    this.isGRNAllExporting = false;
                })
                .catch((error) => {
                    this.isGRNAllExporting = false;
                    console.error("Error exporting data:", error);
                });
        },

        exportGRMExcessData() {
            this.isExcessExporting = true
            const url = "/api/v2/amazon/report_download";
            const payload = {
                ...this.viewGRNExcessTableData,
                name: "Export GRN Excess"
            };
            this.$http.post(url, payload)
                .then((response) => {
                    window.location = response.data?.data;
                    this.isExcessExporting = false;
                })
                .catch((error) => {
                    this.isExcessExporting = false;
                    console.error("Error exporting data:", error);
                });
        },
        
        exportGRMShortData() {
            this.isShortExporting = true
            const url = "/api/v2/amazon/report_download";
            const payload = {
                ...this.viewGRNShortTableData,
                name: "Export GRN Short"
            };
            this.$http.post(url, payload)
                .then((response) => {
                    window.location = response.data?.data;
                    this.isShortExporting = false;
                })
                .catch((error) => {
                    this.isShortExporting = false;
                    console.error("Error exporting data:", error);
                });
        },


        processTable(id) {
            $(id).DataTable().destroy();
            $(id).DataTable({
                searching: true,
                info: true,
                ordering: true,
                order: [],
                columnDefs: [
                    {
                        targets: 0,
                        className: "min-width-column",
                    },
                ],
                initComplete: function () {
                    $(id).wrap(
                        "<div style='overflow:auto; width:100%;position:relative;'></div>"
                    );
                },
                language: {
                    search: "",
                    searchPlaceholder: "Search...",
                    paginate: {
                        first: "",
                        previous: "<",
                        next: ">",
                        last: "",
                    },
                    lengthMenu: "<h5>Show entries</h5> _MENU_",
                },
            });
            $(id + "_filter > label").append(
                `<div class='search_icon'><img src='/Icons_SVG/Search.svg' width='20' /></div>`
            );
        },
    },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.card {
    /* margin-bottom: 1rem !important; */
}

.exportButton {
    margin-left: 6px;
    /* height: 35px; */
    border: none;
    background: var(--primary_brand);
    color: white;
    border-radius: 5px;
    font-weight: 600;
    padding: 0px 25px;
    letter-spacing: 0.2px;
}

.tab-label {
    cursor: pointer;
    padding-bottom: 12px;
    transition: all 0.3s ease;
    font-size: 16px;
    font-weight: 500;
}

.tab-label.active {
    color: rgba(6, 85, 89, 1);
    border-bottom: 1px solid rgba(6, 85, 89, 1);
    font-weight: 600 !important;
}

.stepper-container {
    padding: 20px;
    font-family: sans-serif;
}

.steps {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.step {
    font-weight: 600;
    color: #999;
}

.step.active {
    color: #065559;
    font-weight: bold;
}

.step-circle.active {
    background-color: #065559;
    color: white;
    padding: 10px;
    border-radius: 50%;
}

.line {
    flex-grow: 1;
    height: 2px;
    background-color: #ccc;
    margin: 0 10px;
}

.input-box {
    width: 100%;
    padding: 10px;
    border: 1px solid #aeaeae;
    border-radius: 5px;
    margin-bottom: 16px;
}

.suggestions {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.sku-pill {
    border: 1px solid #aeaeae;
    border-radius: 20px;
    padding: 6px 12px;
    background: white;
    cursor: pointer;
}

.button-group {
    text-align: right;
}

button.primarycolor {
    background: var(--primary_brand);
    font-family: "Poppins", sans-serif;
    color: white;
    padding: 5px 25px;
    border-radius: 6px;
    letter-spacing: 0.2px;
    font-weight: bold;
    font-size: 16px;
}

button.primarycolor:hover {
    color: white;
    background: var(--primary_brand-80);
}

.navigationButton {
    height: 35px;
    border: none;
    margin: 0;
    background: var(--accent_color);
    color: white;
    border-radius: 5px;
    font-size: 16px;
    font-weight: bold;
    padding: 0px 20px;
    letter-spacing: 0.2px;
    font-family: "poppins";
}

.navigationButton:hover {
    background: var(--accent_color-80);
}
</style>
<style>
@media only screen and (max-width: 600px) {
    .daterangepicker .drp-calendar {
        display: none;
        max-width: 270px;
        width: 240px;
    }
}

.vue-daterange-picker .daterangepicker div.ranges {
    min-width: 94px;
}

.daterangepicker.opensright[data-v-1ebd09d2] {
    left: 0px;
    right: auto;
}


#werehouseDateRange .multiselect__tags {
    border: 1px solid #ccc !important;
    max-height: 20px !important;
}

#werehouseDateRange .reportrange-text {
    height: 34px !important;
    width: 180px !important;
}

#werehouseDateRange .reportrange-text span {
    font-size: 16px !important;
}

.borderBetweenTab {
    border-bottom: 1px solid rgba(213, 213, 213, 1) !important;
    margin-bottom: 15px !important;
}
</style>